export default __webpack_public_path__ + "static/media/nikhil.8741053a.jpg";